import _ from 'lodash'
import $ from 'jquery'

import TweenMax, { Back, Power1 } from 'gsap'
import { easeOutQuad } from '../../core/utils/KEasing'
import { POSITION } from './constants'

const gap = 6

export default {
  name: 'KQueueTransition',
  props: {
    position: {
      // 决定每个 item 添加和移除时的 transformOrigin
      type: String,
      default: POSITION.topCenter,
    },
    reverse: {
      // 为 true 则 新添加的 item 排在队尾，显示在 position 的位置
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {}
  },
  computed: {
    positions() {
      const positions = _.lowerCase(this.position).split(/\s/)
      return {
        x: positions[1],
        y: positions[0],
      }
    },
    isBottom() {
      return this.positions.y === 'bottom'
    },
    isCenter() {
      return this.positions.x === 'center'
    },
    isLeft() {
      return this.positions.x === 'left'
    },
    isRight() {
      return this.positions.x === 'right'
    },
  },
  render(h) {
    const myData = {
      css: false,
      on: {
        beforeEnter: this.beforeEnter,
        enter: this.enter,
        afterEnter: this.afterEnter,
        beforeLeave: this.beforeLeave,
        leave: this.leave,
        afterLeave: this.afterLeave,
      },
      ref: 'queue',
      tag: 'div',
    }

    return h('transition-group', myData, this.$slots.default)
  },
  methods: {
    getChildren() {
      // 新来的消息排在队尾，显示在触发方向的最前面
      return this.reverse || this.isBottom ? _.reverse(_.clone(this.$refs.queue.$children)) : this.$refs.queue.$children
      // return _.clone(this.$refs.queue.$children)
    },
    getTransformOrigin(elm) {
      const originX = this.positions.x
      const originY = this.isBottom ? $(elm).outerHeight() - gap : gap
      return `${originX} ${originY}px`
    },
    updateQueue({ addElm, removeElm }, done) {
      const items = this.getChildren()

      if (addElm) {
        let preItem
        let y = 0

        _.forEach(items, (item) => {
          if (preItem) {
            y += $(preItem.$el).outerHeight(true)
          }
          preItem = item

          if (addElm === item.$el) {
            const fromState = {
              transformOrigin: this.getTransformOrigin(addElm),
              y,
              opacity: 0,
              ease: Back.easeOut.config(1),
              onComplete: () => {
                done()
              },
            }

            if (this.isCenter) {
              fromState.scale = 0.1
            } else if (this.isLeft) {
              fromState.x = '-100%'
              fromState.transformOrigin = this.getTransformOrigin(addElm)
            } else if (this.isRight) {
              fromState.x = '100%'
              fromState.transformOrigin = this.getTransformOrigin(addElm)
            }

            TweenMax.from(addElm, 0.6, fromState)
          }

          TweenMax.to(item.$el, 0.6, {
            y: this.isBottom ? -y : y,
            ease: Back.easeOut.config(1.4),
          })
        })
      } else if (removeElm) {
        const removeIndex = _.findIndex(items, ['$el', removeElm])
        if (removeIndex > -1) {
          let preItem
          let y = -$(removeElm).outerHeight(true)

          _.forEach(items, (item, index) => {
            if (preItem) {
              y += $(preItem.$el).outerHeight(true)
            }
            preItem = item

            if (index > removeIndex) {
              TweenMax.to(item.$el, 0.3, {
                y: `${this.isBottom ? '-' : '+'}${y}`,
                ease: Power1.easeOut,
                delay: easeOutQuad((index - removeIndex) * 0.03),
              })
            }
          })
        }
      }
    },
    // beforeEnter(el) {
    beforeEnter() {
    },
    enter(el, done) {
      this.updateQueue({ addElm: el }, done)
    },
    afterEnter() {
      // this.$emit('entered', el)
    },
    beforeLeave(el) {
      el.style.zIndex = -1
    },
    leave(el, done) {
      const items = this.getChildren()
      const duration = items.length === 1 ? 0.3 : 0.6

      const toState = {
        opacity: 0,
        ease: Power1.easeOut,
        onComplete: () => {
          done()
        },
      }

      if (this.isCenter) {
        toState.y = `${this.isBottom ? '+' : '-'}=50`
      } else if (this.isLeft) {
        toState.x = `-100%`
      } else if (this.isRight) {
        toState.x = `100%`
      }

      TweenMax.to(el, duration, toState)
      this.updateQueue({ removeElm: el })
    },
    afterLeave() {
      // this.$emit('left', el)
    },
  },
}
